import { render, staticRenderFns } from "./PlanSelector.vue?vue&type=template&id=2508da03"
import script from "./PlanSelector.vue?vue&type=script&lang=js"
export * from "./PlanSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports